import formMainTagsWhiteLabel from './formMainTagsWhiteLabel';

export default {
  title: 'App Tags',
  attributeName: 'tags',
  getURL: 'appTagsPlay',
  createURL: 'appTagsPlay',
  updateURL: 'appId/appTagsPlay',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: ['appId'],
  formConfig: [formMainTagsWhiteLabel],
  noArea: true,
  goBack: true,
  idUpdate: true
};
